import React, { useEffect, useState } from "react";
import { Table, Input, Space, message, Row, Col, Button, Select } from "antd";
import {
  CloseOutlined,
  DownOutlined,
  PlusOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { ReactComponent as EditIcon } from "../../assets/edit-icon.svg";
import { ReactComponent as DeleteIcon } from "../../assets/delete-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteTenant,
  fetchAllTenants,
  setTenantDetailsIsEdit,
  setStorage,
} from "./redux/actions";
import SpinnerComponent from "../../components/spinner";
import { useNavigate } from "react-router-dom";
// import { baseURL } from "../../../../globalUtils/axiosConfig";
import { baseURL } from "../../globalUtils/axiosConfig";
import _ from "lodash";
import CustomPagination from "../../components/customPagination/CustomPagination";
import { capitalizeFirstLetterofEachWord } from "../../globalUtils/capitalizeFirstLetterofEachWord";
import { getTenantLabel, tenantSourceOptions } from "./utils";
// import moment from 'moment';
// import CustomCalendar from '../../components/calendar';
// import AMultiSelect from '../../components/AMultiSelect';
import sampleImg from "../../assets/logo.png";
const { Option } = Select;

const TenantsTable = ({ canUpdate, canDelete }) => {
  const [sortedInfo, setSortedInfo] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [currentDelRecord, setCurrentDelRecord] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(() => 1);
  const [resultPerPage, setResultPerPage] = useState(() => 10);
  const [req, setReq] = useState(false);
  const [search, setSearch] = useState({});
  const [defaultPageOneReq, setDefaultPageOneReq] = useState(false);
  // const [statusCheckedList, setStatusCheckedList] = useState([]);
  // const [regionsCheckedList, setRegionsCheckedList] = useState([]);
  const [datePickerOpened, setDatePickerOpened] = useState(false);
  // const [date, setDate] = useState(null);
  // const [tenantStatuses, SetTenantStatuses] = useState([]);
  // const [tenantRegions, SetTenantRegions] = useState([]);

  const { allTenants, fetchTenantsLoading, deleteTenantLoading, totalRecords } =
    useSelector((state) => state.tenantsReducer);

  useEffect(() => {
    if (localStorage.getItem("tenantsManagerState")) {
      const localStorageData = JSON.parse(
        localStorage.getItem("tenantsManagerState")
      );

      if (localStorageData?.search?.name) {
        setTimeout(() => {
          setSearch(localStorageData.search);
          dispatch(setStorage(localStorageData));

          debouncedCallApi();
        }, 2000);
      }
    }
  }, []);

  useEffect(() => {
    // let updatedData = allTenants.filter((el) =>
    //   el.name?.toLowerCase().includes(search?.name?.toLowerCase().trim())
    // );

    // setDataSource(updatedData);
    if (page && resultPerPage && page > 0 && resultPerPage > 0) {
      dispatch(
        fetchAllTenants({
          page: page,
          per_page: resultPerPage,
          search,
          sort: sortedInfo?.order && sortedInfo?.columnKey,
          order: sortedInfo?.order
            ? sortedInfo?.order === "ascend"
              ? 1
              : -1
            : null,
        })
      );
    }
  }, [req]);

  useEffect(() => {
    let paramsPage = 1;
    if (paramsPage && resultPerPage && paramsPage > 0 && resultPerPage > 0) {
      dispatch(
        fetchAllTenants({
          page: paramsPage,
          per_page: resultPerPage,
          search,
        })
      );
      setPage(1);
    }
  }, [defaultPageOneReq]);

  useEffect(() => {
    debouncedCallApi();
  }, [sortedInfo]);

  // useEffect(() => {
  //   dispatch(fetchAllTenants({ search: {} }));

  //   // return () => {
  //   //   dispatch(isAddingAction(false));
  //   // };
  // }, []);

  const [debouncedCallApi] = useState(() =>
    _.debounce(() => setReq((prev) => !prev), 1000)
  );

  const [debouncedDefaultPageOneCallApi] = useState(() =>
    _.debounce(() => setDefaultPageOneReq((prev) => !prev), 1000)
  );

  useEffect(() => {
    setDataSource(allTenants);
  }, [allTenants]);

  const handleSelectOnchange = (value, options, key, setHandler) => {
    if (value.includes("all")) {
      setHandler([...options.map((item) => item.value)]);
      value = options.map((item) => item.value);
    } else if (value.includes("not-all")) {
      setHandler([]);
      value = [];
    } else {
      setHandler(value);
    }
    handleMultiSelect(value, key);
  };
  const handleMultiSelect = (list, key) => {
    setSearch({
      ...search,
      [key]: list,
    });
  };

  const handleChange = (pagination, filters, sorter) => {
    if (datePickerOpened) {
      return;
    }
    setSortedInfo(sorter);
  };

  const handleDelete = (record) => {
    const tenants = record?.learning_activity_tenants?.length || 0;
    const curriculums = record?.curriculums?.length || 0;

    if (tenants > 0 || curriculums > 0) {
      message.error(
        "This tenant is associated with learning activities or curriculums."
      );
      return;
    } else {
      setCurrentDelRecord(record);
      dispatch(deleteTenant({ _id: record._id }));
    }
  };

  const handleSetStorage = (key, value) => {
    dispatch(setStorage({ [key]: value }));
  };

  const handleSearch = (key, value, func = null) => {
    let updatedState = {
      ...search,
      [key]: value,
    };

    setSearch(updatedState);

    if (typeof func === "function") {
      func();
    }

    // let updatedData = allTenants.filter((el) =>
    //   el.name?.toLowerCase().includes(value?.toLowerCase().trim())
    // );

    // setDataSource(updatedData);

    dispatch(setStorage({ search: updatedState }));
    handleSetStorage("search", updatedState);
  };

  const searchInput = (key) => (
    <Input
      onClick={(e) => e.stopPropagation()}
      value={search[key]}
      onChange={(e) => {
        handleSearch(key, e.target.value, debouncedDefaultPageOneCallApi);
      }}
    />
  );

  const handleNavigate = (id) => navigate(`/institute-management/update/${id}`);

  const handleDownload = (url) => {
    window.open(url, "_blank");
  };

  const columns = [
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">Logo</div>
            <div></div>
          </div>
        );
      },
      dataIndex: "logo_path",
      key: "logo_path",
      sorter: false,
      sortOrder: sortedInfo?.columnKey === "logo_path" && sortedInfo?.order,
      ellipsis: true,
      width: "15%",
      render: (logo_path, { _id }) => (
        <div
          // onClick={() => handleNavigate(_id)}
          style={{
            width: "50px",
            height: "50px",
          }}
        >
          <img
            width="100%"
            height="100%"
            style={{
              borderRadius: "50%",
              objectFit: "fill",
            }}
            src={logo_path ? `${baseURL}/${logo_path}` : sampleImg}
            alt=""
          />
        </div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" style={{ width: "100%" }}>
            <div className="special-table-header-text">Name</div>
            <div>{searchInput("name")}</div>
          </div>
        );
      },
      dataIndex: "name",
      key: "name",
      // sorter: (a, b) =>
      //   a.name?.toLowerCase()?.localeCompare(b.name?.toLowerCase()),
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "name" && sortedInfo?.order,
      ellipsis: true,
      width: "30%",
      render: (name, { _id }) => (
        <div onClick={() => handleNavigate(_id)}>{name}</div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">Login Options</div>
            <div>
              <Select
                style={{
                  width: "100%",
                  // minHeight: '20px',
                  fontSize: "12px",
                  textTransform: "capitalize",
                }}
                size="middle"
                onClick={(e) => e.stopPropagation()}
                allowClear={true}
                readOnly={true}
                className="Select Login Options"
                dropdownClassName="select-dropdown-custom"
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                value={search?.sources || null}
                showSearch
                placeholder=""
                optionFilterProp="children"
                onChange={(e) => {
                  handleSearch("sources", e, debouncedDefaultPageOneCallApi);
                }}
                optionLabelProp="label"
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {tenantSourceOptions?.map(({ label, key }) => {
                  return (
                    <Option value={key} label={label}>
                      {label || ""}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
        );
      },
      dataIndex: "sources",
      key: "sources",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "sources" && sortedInfo?.order,
      ellipsis: true,
      width: "30%",
      align: "center",
      render: (_, record) => {
        let sourcesString = "";

        const sources = record?.config?.login?.sources || [];

        if (sources) {
          sourcesString = sources?.map((el) => getTenantLabel(el))?.join(", ");
        }

        return <div>{sourcesString}</div>;
      },
    },
    {
      title: () => {
        return (
          <div align="top" style={{ width: "100%" }}>
            <div className="special-table-header-text">Type</div>
            <div key={"1"}>
              <Select
                style={{
                  width: "100%",
                  textTransform: "capitalize",
                }}
                size="small"
                onClick={(e) => e.stopPropagation()}
                allowClear={true}
                readOnly={true}
                className="Select Type"
                dropdownClassName="select-dropdown-custom"
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                showSearch
                placeholder=""
                value={search?.type}
                optionFilterProp="children"
                onChange={(e) => handleSearch("type", e, debouncedCallApi)}
                optionLabelProp="label"
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {[
                  { label: "PUBLIC", value: "public" },
                  { label: "PRIVATE", value: "private" },
                ]?.map(({ label, value }) => {
                  return (
                    <Option value={value} label={label}>
                      {label || ""}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
        );
      },
      dataIndex: "type",
      key: "type",
      width: "30%",
      editable: true,
      align: "center",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "type" && sortedInfo?.order,
      ellipsis: true,
      sorter: (a, b) => a.type?.localeCompare(b.type),
      render: (type) => {
        return <div style={{ paddingLeft: "12px" }}>{type?.toUpperCase()}</div>;
      },
    },
    {
      title: null,
      dataIndex: "",
      key: "action",
      width: "20%",
      align: "center",
      render: (_, record) => {
        // if (!canUpdate && !canDelete) {
        //   return;
        // }
        return deleteTenantLoading && record._id === currentDelRecord._id ? (
          <SpinnerComponent fontSize={14} />
        ) : (
          <Space size={15} align="baseline">
            {/* {canUpdate && ( */}
            <EditIcon
              width={18}
              height={18}
              className="custom-icon"
              onClick={() => {
                handleNavigate(record._id);
                dispatch(setTenantDetailsIsEdit(true));
              }}
            />
            {/* // )} */}
            {/* {canDelete && ( */}
            {/* <Popconfirm
              title='Are you sure you want to delete this tenant?'
              onConfirm={() => handleDelete(record)}
              okText='Yes'
              cancelText='No'
            >
              <DeleteIcon width={18} height={18} className='custom-icon' />
            </Popconfirm> */}
            {/* )} */}
          </Space>
        );
      },
    },
  ];

  return (
    <div className="page-top-div">
      <span className="text-span">Institutes</span>
      <Row className="production-manager-parent-row">
        <Col span={24} className="heading-col">
          <Row align="middle" gutter={[50, 0]} justify="space-between">
            <Col>
              <Row align="middle" gutter={[30, 0]}>
                <Col>
                  <div>
                    <span className="heading-span">Institutes Register</span>
                  </div>
                </Col>
                <Col>
                  <Button
                    onClick={() => {
                      navigate("/institute-management/create");
                      dispatch(setTenantDetailsIsEdit(true));
                    }}
                    icon={<PlusOutlined />}
                    className="add-user-btn"
                    size="middle"
                    style={{
                      width: "105%",
                    }}
                  >
                    Institute
                  </Button>
                </Col>
                <Col>
                  <Button
                    onClick={() => {
                      handleSetStorage("search", {});
                      handleSetStorage("sortedInfo", null);
                      handleSetStorage("page", 1);
                      handleSetStorage("resultPerPage", 10);
                      setPage(1);
                      setResultPerPage(10);
                      setSearch({});
                      setSortedInfo(null);
                      debouncedCallApi();
                    }}
                    icon={<CloseOutlined />}
                    className="add-user-btn"
                    size="middle"
                  >
                    Clear Filters
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Table
            className="special-table"
            columns={columns}
            scroll={{ x: !fetchTenantsLoading }}
            onChange={handleChange}
            dataSource={dataSource}
            pagination={false}
            sortUpIcon={<UpOutlined />}
            sortDownIcon={<DownOutlined />}
            loading={fetchTenantsLoading}
          />
          <CustomPagination
            page={page}
            setPage={setPage}
            resultPerPage={resultPerPage}
            setResultPerPage={setResultPerPage}
            debouncedCallApi={debouncedCallApi}
            totalRecord={totalRecords}
          />
        </Col>
      </Row>
    </div>
  );
};

export default TenantsTable;
